import { useState } from 'react'
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@mui/material'

interface RefetchConfirmDialogProps {
  open: boolean
  onClose: () => void
  onSinglePage: () => void
  onFullCrawl: (saveAsOrgWebsite: boolean) => void
  isLoading: boolean
  showSaveAsWebsite?: boolean
}

export default function RefetchConfirmDialog({
  open,
  onClose,
  onSinglePage,
  onFullCrawl,
  isLoading,
  showSaveAsWebsite = false,
}: RefetchConfirmDialogProps) {
  const [saveAsWebsite, setSaveAsWebsite] = useState(false)

  const handleFullCrawl = () => {
    onFullCrawl(saveAsWebsite)
    setSaveAsWebsite(false)
  }

  const handleClose = () => {
    setSaveAsWebsite(false)
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Refresh the uploaded content for this website</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          This looks like your organisation's main website. When we first added
          it, we may have saved content from other pages on the site too.
        </Typography>
        <Typography variant="body1" sx={{ mt: 1.5 }}>
          Would you like to update just this page, or refresh all the pages
          we've already saved from this website?
        </Typography>
        {showSaveAsWebsite && (
          <FormControlLabel
            sx={{ mt: 2 }}
            control={
              <Checkbox
                checked={saveAsWebsite}
                onChange={(e) => setSaveAsWebsite(e.target.checked)}
                disabled={isLoading}
              />
            }
            label="Save this as my organisation's main website"
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button onClick={onSinglePage} disabled={isLoading} variant="outlined">
          Just this page
        </Button>
        <Button onClick={handleFullCrawl} disabled={isLoading} variant="contained">
          Update all the pages
        </Button>
      </DialogActions>
    </Dialog>
  )
}
